const MockData = [
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'SCTB',
    submittedAt: '2025-05-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SCTB',
    submittedAt: '2024-11-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'XPWP',
    submittedAt: '2025-02-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XPWP',
    submittedAt: '2025-03-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'LYUZ',
    submittedAt: '2025-04-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LYUZ',
    submittedAt: '2025-05-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'AQWP',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'AQWP',
    submittedAt: '2025-04-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'XXYJ',
    submittedAt: '2025-02-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XXYJ',
    submittedAt: '2025-03-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'YCWL',
    submittedAt: '2025-05-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YCWL',
    submittedAt: '2025-05-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'RFEW',
    submittedAt: '2025-01-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RFEW',
    submittedAt: '2025-02-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'GQBR',
    submittedAt: '2025-05-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GQBR',
    submittedAt: '2024-11-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OGIP',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'OGIP',
    submittedAt: '2025-01-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'VXAS',
    submittedAt: '2024-11-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VXAS',
    submittedAt: '2024-12-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BJCZ',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BJCZ',
    submittedAt: '2024-11-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'LSFF',
    submittedAt: '2025-05-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'LSFF',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WXIO',
    submittedAt: '2025-04-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WXIO',
    submittedAt: '2025-05-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'FJAA',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FJAA',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'RAXU',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RAXU',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'HFLY',
    submittedAt: '2025-04-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'HFLY',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'KKLY',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KKLY',
    submittedAt: '2025-02-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'QJSL',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QJSL',
    submittedAt: '2025-04-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'WQLD',
    submittedAt: '2025-05-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WQLD',
    submittedAt: '2025-05-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PDML',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PDML',
    submittedAt: '2024-12-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'SQCB',
    submittedAt: '2025-02-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SQCB',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'RPAV',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RPAV',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'BMYB',
    submittedAt: '2025-04-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BMYB',
    submittedAt: '2025-04-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'JOWG',
    submittedAt: '2025-02-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JOWG',
    submittedAt: '2025-03-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'XAKR',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XAKR',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'MCGG',
    submittedAt: '2025-04-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'MCGG',
    submittedAt: '2025-04-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ETBJ',
    submittedAt: '2025-04-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ETBJ',
    submittedAt: '2025-04-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'ETSL',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ETSL',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'DWJS',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'DWJS',
    submittedAt: '2025-04-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'TDXJ',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TDXJ',
    submittedAt: '2025-02-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'CCIR',
    submittedAt: '2025-03-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CCIR',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'ZAYC',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZAYC',
    submittedAt: '2024-11-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'BEAS',
    submittedAt: '2025-03-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BEAS',
    submittedAt: '2025-03-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'QXWR',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QXWR',
    submittedAt: '2024-11-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'SUZY',
    submittedAt: '2025-01-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SUZY',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'CHLP',
    submittedAt: '2025-05-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CHLP',
    submittedAt: '2024-11-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'HEQC',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HEQC',
    submittedAt: '2025-02-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'JJEP',
    submittedAt: '2025-05-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JJEP',
    submittedAt: '2025-05-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'JIKQ',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JIKQ',
    submittedAt: '2025-03-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'CJEE',
    submittedAt: '2025-03-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CJEE',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WYQS',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WYQS',
    submittedAt: '2025-05-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'DYWP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'DYWP',
    submittedAt: '2024-11-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OYFD',
    submittedAt: '2025-01-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OYFD',
    submittedAt: '2025-02-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'CGRB',
    submittedAt: '2025-03-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CGRB',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'XZKN',
    submittedAt: '2025-01-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XZKN',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'TRJU',
    submittedAt: '2025-03-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TRJU',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'OOQN',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OOQN',
    submittedAt: '2024-11-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'VTFN',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VTFN',
    submittedAt: '2025-02-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'RJHS',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'RJHS',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'QOKM',
    submittedAt: '2025-01-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QOKM',
    submittedAt: '2025-01-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'DJTN',
    submittedAt: '2025-04-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'DJTN',
    submittedAt: '2025-04-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'FVGY',
    submittedAt: '2025-05-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FVGY',
    submittedAt: '2024-11-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'TFRC',
    submittedAt: '2025-05-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'TFRC',
    submittedAt: '2025-05-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'VGGI',
    submittedAt: '2025-03-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VGGI',
    submittedAt: '2025-04-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'YNAN',
    submittedAt: '2025-01-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YNAN',
    submittedAt: '2025-01-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'IQIC',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IQIC',
    submittedAt: '2024-11-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'DIEK',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DIEK',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'XYXJ',
    submittedAt: '2025-03-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'XYXJ',
    submittedAt: '2025-04-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'YTKF',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YTKF',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ZOWQ',
    submittedAt: '2025-05-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZOWQ',
    submittedAt: '2025-05-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'JWGI',
    submittedAt: '2024-11-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JWGI',
    submittedAt: '2024-11-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PJLM',
    submittedAt: '2025-04-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PJLM',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WEMV',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WEMV',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'RPTS',
    submittedAt: '2025-03-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RPTS',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UBET',
    submittedAt: '2025-02-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UBET',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ENOW',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ENOW',
    submittedAt: '2025-05-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'UIDH',
    submittedAt: '2025-02-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UIDH',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'AERJ',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'AERJ',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OFAQ',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OFAQ',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ODVI',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ODVI',
    submittedAt: '2024-11-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'RUDU',
    submittedAt: '2024-11-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'RUDU',
    submittedAt: '2024-11-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'DVIW',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DVIW',
    submittedAt: '2025-05-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'EOON',
    submittedAt: '2025-04-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EOON',
    submittedAt: '2025-05-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'XWOS',
    submittedAt: '2025-03-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XWOS',
    submittedAt: '2025-03-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'NBJT',
    submittedAt: '2025-03-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'NBJT',
    submittedAt: '2025-03-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'WIBA',
    submittedAt: '2025-05-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WIBA',
    submittedAt: '2024-11-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'IQJH',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'IQJH',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'AUWB',
    submittedAt: '2025-03-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'AUWB',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'JUFZ',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JUFZ',
    submittedAt: '2025-03-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UGLF',
    submittedAt: '2025-05-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UGLF',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'PGRP',
    submittedAt: '2025-02-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'PGRP',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'CUKE',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CUKE',
    submittedAt: '2025-03-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'YKVG',
    submittedAt: '2025-05-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YKVG',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'LURT',
    submittedAt: '2025-03-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LURT',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'EQAT',
    submittedAt: '2024-11-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'EQAT',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'TQZQ',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TQZQ',
    submittedAt: '2025-04-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'FZMN',
    submittedAt: '2025-05-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FZMN',
    submittedAt: '2024-11-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'POOK',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'POOK',
    submittedAt: '2024-11-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'GSUY',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'GSUY',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'MFGB',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'MFGB',
    submittedAt: '2024-11-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'GDPA',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'GDPA',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'SVZY',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SVZY',
    submittedAt: '2025-04-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'EQTB',
    submittedAt: '2025-03-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EQTB',
    submittedAt: '2025-04-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BNKK',
    submittedAt: '2025-05-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BNKK',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'AJGU',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'AJGU',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'SMSZ',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SMSZ',
    submittedAt: '2025-02-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'JMVU',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'JMVU',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ZDMN',
    submittedAt: '2024-11-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZDMN',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'KXAM',
    submittedAt: '2025-05-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KXAM',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'TNRL',
    submittedAt: '2025-01-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TNRL',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'MKGY',
    submittedAt: '2025-03-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'MKGY',
    submittedAt: '2025-04-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'TEOA',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TEOA',
    submittedAt: '2024-11-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ZUZY',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZUZY',
    submittedAt: '2024-11-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'AAVI',
    submittedAt: '2025-03-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'AAVI',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'LDRO',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LDRO',
    submittedAt: '2025-05-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'RPSR',
    submittedAt: '2025-03-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RPSR',
    submittedAt: '2025-03-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'KSVQ',
    submittedAt: '2025-01-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KSVQ',
    submittedAt: '2025-02-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'QLOB',
    submittedAt: '2025-05-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'QLOB',
    submittedAt: '2025-05-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'WYTA',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WYTA',
    submittedAt: '2024-12-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'THAS',
    submittedAt: '2024-11-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'THAS',
    submittedAt: '2024-11-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'IQJQ',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'IQJQ',
    submittedAt: '2025-03-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'MXZF',
    submittedAt: '2025-01-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'MXZF',
    submittedAt: '2025-02-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OLYX',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OLYX',
    submittedAt: '2025-01-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ZWQW',
    submittedAt: '2025-01-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZWQW',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'SBSD',
    submittedAt: '2025-04-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'SBSD',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'VDIJ',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VDIJ',
    submittedAt: '2024-11-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'FELC',
    submittedAt: '2025-02-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FELC',
    submittedAt: '2025-03-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'ICHL',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ICHL',
    submittedAt: '2024-11-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'SRWE',
    submittedAt: '2025-05-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'SRWE',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'CZVU',
    submittedAt: '2025-04-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CZVU',
    submittedAt: '2025-05-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'HHFM',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HHFM',
    submittedAt: '2025-05-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'NOLR',
    submittedAt: '2024-11-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'NOLR',
    submittedAt: '2024-11-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'UULI',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UULI',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'KSCD',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'KSCD',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UUSE',
    submittedAt: '2025-01-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'UUSE',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'LLAE',
    submittedAt: '2025-04-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LLAE',
    submittedAt: '2025-05-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'CJNP',
    submittedAt: '2025-05-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CJNP',
    submittedAt: '2025-05-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'FTSV',
    submittedAt: '2025-01-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FTSV',
    submittedAt: '2025-01-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'PVZI',
    submittedAt: '2025-02-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'PVZI',
    submittedAt: '2025-02-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'CRCC',
    submittedAt: '2025-02-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CRCC',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'LBQP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LBQP',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ZIKM',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZIKM',
    submittedAt: '2025-04-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'QHWA',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QHWA',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'WBNZ',
    submittedAt: '2024-11-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WBNZ',
    submittedAt: '2024-12-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'YXUH',
    submittedAt: '2025-03-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YXUH',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'MXOY',
    submittedAt: '2025-04-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'MXOY',
    submittedAt: '2025-05-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'RMTX',
    submittedAt: '2025-01-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'RMTX',
    submittedAt: '2025-01-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'XCBY',
    submittedAt: '2025-04-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XCBY',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'VNHX',
    submittedAt: '2025-01-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VNHX',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'BJNS',
    submittedAt: '2025-02-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BJNS',
    submittedAt: '2025-02-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'XEXZ',
    submittedAt: '2025-02-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XEXZ',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BTZV',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BTZV',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'VGID',
    submittedAt: '2025-04-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VGID',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ZQVB',
    submittedAt: '2025-03-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZQVB',
    submittedAt: '2025-04-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'JKWG',
    submittedAt: '2025-04-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JKWG',
    submittedAt: '2025-04-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'WLTH',
    submittedAt: '2025-05-22',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WLTH',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'ZLUI',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZLUI',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'EGKC',
    submittedAt: '2025-04-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EGKC',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'TKUF',
    submittedAt: '2025-03-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TKUF',
    submittedAt: '2025-04-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'UTOF',
    submittedAt: '2025-04-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UTOF',
    submittedAt: '2025-05-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'KPER',
    submittedAt: '2025-04-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'KPER',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WTJQ',
    submittedAt: '2025-03-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WTJQ',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'HTFU',
    submittedAt: '2024-11-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'HTFU',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'CPVP',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CPVP',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OYFP',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OYFP',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'GOYK',
    submittedAt: '2025-01-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GOYK',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'EEXL',
    submittedAt: '2025-01-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'EEXL',
    submittedAt: '2025-02-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'NUTJ',
    submittedAt: '2025-02-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'NUTJ',
    submittedAt: '2025-02-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'IVTM',
    submittedAt: '2025-04-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IVTM',
    submittedAt: '2025-04-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'LFFE',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LFFE',
    submittedAt: '2025-05-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ZCOM',
    submittedAt: '2025-02-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZCOM',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BRHV',
    submittedAt: '2025-05-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BRHV',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'AAOF',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'AAOF',
    submittedAt: '2025-05-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'RLDL',
    submittedAt: '2025-02-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RLDL',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'QZYN',
    submittedAt: '2025-05-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'QZYN',
    submittedAt: '2025-05-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'VAUP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VAUP',
    submittedAt: '2024-11-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UKNJ',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UKNJ',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'EXWG',
    submittedAt: '2025-01-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'EXWG',
    submittedAt: '2025-01-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ENKZ',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ENKZ',
    submittedAt: '2025-03-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'JFUO',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JFUO',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'DFMH',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DFMH',
    submittedAt: '2025-05-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'KMAN',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'KMAN',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WYZU',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WYZU',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'DHAG',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'DHAG',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'TAUV',
    submittedAt: '2025-01-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'TAUV',
    submittedAt: '2025-01-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'FUMQ',
    submittedAt: '2024-11-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FUMQ',
    submittedAt: '2024-12-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'PYLA',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PYLA',
    submittedAt: '2025-03-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BBEY',
    submittedAt: '2025-04-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BBEY',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'JMUM',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JMUM',
    submittedAt: '2025-03-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'YBHG',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YBHG',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'YORM',
    submittedAt: '2025-04-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YORM',
    submittedAt: '2025-04-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'GOYQ',
    submittedAt: '2024-11-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'GOYQ',
    submittedAt: '2024-11-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'WCXX',
    submittedAt: '2025-02-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WCXX',
    submittedAt: '2025-02-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'BOOM',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BOOM',
    submittedAt: '2025-04-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'VAXJ',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VAXJ',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'WZOQ',
    submittedAt: '2025-04-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WZOQ',
    submittedAt: '2025-04-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'KPKW',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KPKW',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'BTZZ',
    submittedAt: '2025-05-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BTZZ',
    submittedAt: '2024-11-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'KKDX',
    submittedAt: '2025-05-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KKDX',
    submittedAt: '2025-05-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'IEQW',
    submittedAt: '2025-02-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IEQW',
    submittedAt: '2025-03-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'ZFBV',
    submittedAt: '2025-01-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZFBV',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'RCVR',
    submittedAt: '2025-03-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RCVR',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'RCGS',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RCGS',
    submittedAt: '2025-02-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'WHZL',
    submittedAt: '2025-01-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WHZL',
    submittedAt: '2025-02-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'VPBE',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VPBE',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ZBIC',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZBIC',
    submittedAt: '2025-01-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'FJJK',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FJJK',
    submittedAt: '2025-03-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'DFAV',
    submittedAt: '2025-03-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DFAV',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UNPR',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UNPR',
    submittedAt: '2025-05-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'UAUS',
    submittedAt: '2024-11-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UAUS',
    submittedAt: '2024-12-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PPAD',
    submittedAt: '2025-05-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PPAD',
    submittedAt: '2024-11-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'CPTQ',
    submittedAt: '2024-11-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CPTQ',
    submittedAt: '2024-12-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PIBH',
    submittedAt: '2025-04-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PIBH',
    submittedAt: '2025-04-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'NAPN',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NAPN',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'MUKC',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'MUKC',
    submittedAt: '2025-05-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'CSWJ',
    submittedAt: '2025-03-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CSWJ',
    submittedAt: '2025-04-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'EART',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EART',
    submittedAt: '2025-05-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'OHUR',
    submittedAt: '2025-05-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OHUR',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PKWD',
    submittedAt: '2025-05-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PKWD',
    submittedAt: '2025-05-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'UXWN',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UXWN',
    submittedAt: '2025-02-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'NLBJ',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NLBJ',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'IJGI',
    submittedAt: '2025-04-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IJGI',
    submittedAt: '2025-04-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'BLCB',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BLCB',
    submittedAt: '2024-12-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'DEWZ',
    submittedAt: '2025-02-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DEWZ',
    submittedAt: '2025-02-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'EIMS',
    submittedAt: '2025-03-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'EIMS',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'PHGQ',
    submittedAt: '2025-02-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PHGQ',
    submittedAt: '2025-02-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'CSAZ',
    submittedAt: '2025-03-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CSAZ',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'ABJP',
    submittedAt: '2025-02-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ABJP',
    submittedAt: '2025-02-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'JYEX',
    submittedAt: '2025-02-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'JYEX',
    submittedAt: '2025-02-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'ORFY',
    submittedAt: '2025-02-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ORFY',
    submittedAt: '2025-02-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'GKYQ',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GKYQ',
    submittedAt: '2025-03-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'OXRZ',
    submittedAt: '2025-01-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OXRZ',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'XJIZ',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XJIZ',
    submittedAt: '2025-02-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'ZYDE',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZYDE',
    submittedAt: '2025-04-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'EIFL',
    submittedAt: '2025-03-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'EIFL',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'ZGMQ',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZGMQ',
    submittedAt: '2024-11-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'FOFY',
    submittedAt: '2025-04-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FOFY',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'EGZS',
    submittedAt: '2025-02-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'EGZS',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'YHHN',
    submittedAt: '2025-04-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YHHN',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'VUIT',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VUIT',
    submittedAt: '2025-02-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'PRNH',
    submittedAt: '2025-02-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'PRNH',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'LKKY',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LKKY',
    submittedAt: '2025-05-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'IFBG',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'IFBG',
    submittedAt: '2025-05-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'XGBQ',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XGBQ',
    submittedAt: '2024-11-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'YFNW',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YFNW',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'QSWP',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QSWP',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'CWSI',
    submittedAt: '2025-01-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CWSI',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'YVQJ',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YVQJ',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'KNDV',
    submittedAt: '2024-11-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KNDV',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'QVEF',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QVEF',
    submittedAt: '2024-12-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'SEEK',
    submittedAt: '2024-11-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SEEK',
    submittedAt: '2024-12-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'DCZH',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DCZH',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'JCTO',
    submittedAt: '2025-01-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JCTO',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'UQAH',
    submittedAt: '2024-11-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UQAH',
    submittedAt: '2024-12-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'FCZO',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FCZO',
    submittedAt: '2024-11-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'JXYS',
    submittedAt: '2025-01-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'JXYS',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'YGDU',
    submittedAt: '2025-05-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YGDU',
    submittedAt: '2025-05-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'COOS',
    submittedAt: '2025-01-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'COOS',
    submittedAt: '2025-02-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'QAFM',
    submittedAt: '2025-02-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'QAFM',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'PQEG',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'PQEG',
    submittedAt: '2024-12-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TRRE',
    submittedAt: '2025-05-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'TRRE',
    submittedAt: '2025-05-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HMIG',
    submittedAt: '2025-01-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HMIG',
    submittedAt: '2025-02-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SKNC',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SKNC',
    submittedAt: '2024-11-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HJFP',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'HJFP',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'EDLC',
    submittedAt: '2025-05-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EDLC',
    submittedAt: '2025-05-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'UBRA',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'UBRA',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VCDU',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'VCDU',
    submittedAt: '2025-04-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EUVZ',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EUVZ',
    submittedAt: '2025-04-06',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SLUD',
    submittedAt: '2024-11-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SLUD',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'UOWA',
    submittedAt: '2025-05-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'UOWA',
    submittedAt: '2025-05-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LADT',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'LADT',
    submittedAt: '2025-02-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'RAOY',
    submittedAt: '2025-02-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RAOY',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'MGMU',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MGMU',
    submittedAt: '2025-05-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WQFQ',
    submittedAt: '2025-03-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'WQFQ',
    submittedAt: '2025-04-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IBSY',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'IBSY',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HXHY',
    submittedAt: '2024-11-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HXHY',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'RPLM',
    submittedAt: '2024-11-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RPLM',
    submittedAt: '2024-11-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RJXL',
    submittedAt: '2025-05-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RJXL',
    submittedAt: '2024-11-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XYHM',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XYHM',
    submittedAt: '2025-03-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'TBWL',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TBWL',
    submittedAt: '2025-05-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HGHI',
    submittedAt: '2025-04-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'HGHI',
    submittedAt: '2025-05-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XFTJ',
    submittedAt: '2025-02-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'XFTJ',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'INCJ',
    submittedAt: '2025-03-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'INCJ',
    submittedAt: '2025-03-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LYXJ',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LYXJ',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'JYSO',
    submittedAt: '2025-01-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JYSO',
    submittedAt: '2025-02-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RTJD',
    submittedAt: '2025-04-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'RTJD',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GITL',
    submittedAt: '2025-02-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GITL',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ROYB',
    submittedAt: '2025-02-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ROYB',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CODB',
    submittedAt: '2024-11-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'CODB',
    submittedAt: '2024-12-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CNVX',
    submittedAt: '2025-01-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'CNVX',
    submittedAt: '2025-01-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'TGIR',
    submittedAt: '2025-03-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TGIR',
    submittedAt: '2025-04-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'NEOJ',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'NEOJ',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SRZK',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'SRZK',
    submittedAt: '2025-03-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'JWXO',
    submittedAt: '2025-03-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JWXO',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'FPSH',
    submittedAt: '2025-02-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FPSH',
    submittedAt: '2025-02-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'KXYY',
    submittedAt: '2025-01-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KXYY',
    submittedAt: '2025-02-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OPXG',
    submittedAt: '2025-01-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'OPXG',
    submittedAt: '2025-02-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VYFB',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'VYFB',
    submittedAt: '2025-01-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'YDNV',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YDNV',
    submittedAt: '2025-03-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'GSLJ',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'GSLJ',
    submittedAt: '2025-03-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'IUQF',
    submittedAt: '2025-04-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'IUQF',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BGIU',
    submittedAt: '2025-01-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BGIU',
    submittedAt: '2025-02-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'CLXJ',
    submittedAt: '2025-05-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CLXJ',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'DEGF',
    submittedAt: '2025-01-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DEGF',
    submittedAt: '2025-02-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WLDH',
    submittedAt: '2025-03-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'WLDH',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CGJY',
    submittedAt: '2025-02-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'CGJY',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZDZB',
    submittedAt: '2024-11-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZDZB',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VAQB',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VAQB',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HLJA',
    submittedAt: '2025-04-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HLJA',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EGVH',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EGVH',
    submittedAt: '2025-03-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EDOA',
    submittedAt: '2025-03-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'EDOA',
    submittedAt: '2025-04-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TLLH',
    submittedAt: '2025-04-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TLLH',
    submittedAt: '2025-04-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WSAF',
    submittedAt: '2025-04-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'WSAF',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HWXB',
    submittedAt: '2025-03-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HWXB',
    submittedAt: '2025-03-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ONKA',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ONKA',
    submittedAt: '2025-05-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'HSOO',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'HSOO',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XJPZ',
    submittedAt: '2025-03-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'XJPZ',
    submittedAt: '2025-04-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VPER',
    submittedAt: '2025-04-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'VPER',
    submittedAt: '2025-05-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'KIUJ',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KIUJ',
    submittedAt: '2025-03-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XGIN',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'XGIN',
    submittedAt: '2024-12-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'RKHB',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RKHB',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VHSF',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VHSF',
    submittedAt: '2025-05-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FLID',
    submittedAt: '2025-02-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'FLID',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BZQG',
    submittedAt: '2025-04-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'BZQG',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SXGW',
    submittedAt: '2025-05-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SXGW',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'LEOY',
    submittedAt: '2025-01-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'LEOY',
    submittedAt: '2025-02-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'TRTK',
    submittedAt: '2025-03-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'TRTK',
    submittedAt: '2025-04-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UZWN',
    submittedAt: '2024-11-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'UZWN',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'MKXC',
    submittedAt: '2025-01-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MKXC',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QQPN',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QQPN',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TDYV',
    submittedAt: '2025-04-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'TDYV',
    submittedAt: '2025-05-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GPHN',
    submittedAt: '2025-05-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'GPHN',
    submittedAt: '2024-11-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'OOJV',
    submittedAt: '2025-01-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'OOJV',
    submittedAt: '2025-01-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ALRB',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ALRB',
    submittedAt: '2024-11-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'OEOD',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'OEOD',
    submittedAt: '2025-03-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GWZK',
    submittedAt: '2025-05-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'GWZK',
    submittedAt: '2024-11-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SDQC',
    submittedAt: '2025-03-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'SDQC',
    submittedAt: '2025-04-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'PPOW',
    submittedAt: '2025-05-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PPOW',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XKGA',
    submittedAt: '2025-04-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'XKGA',
    submittedAt: '2025-05-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XEZB',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'XEZB',
    submittedAt: '2025-03-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VGWF',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'VGWF',
    submittedAt: '2024-12-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SGQI',
    submittedAt: '2025-05-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'SGQI',
    submittedAt: '2024-11-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'GMPQ',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'GMPQ',
    submittedAt: '2024-12-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'DDJA',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DDJA',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'WRPF',
    submittedAt: '2024-11-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WRPF',
    submittedAt: '2024-11-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'IJED',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'IJED',
    submittedAt: '2025-03-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HCSG',
    submittedAt: '2025-05-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HCSG',
    submittedAt: '2025-05-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'FVZO',
    submittedAt: '2025-02-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FVZO',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'YZWB',
    submittedAt: '2025-02-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YZWB',
    submittedAt: '2025-02-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HZLT',
    submittedAt: '2025-02-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HZLT',
    submittedAt: '2025-02-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BDHE',
    submittedAt: '2024-11-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BDHE',
    submittedAt: '2024-11-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BUHC',
    submittedAt: '2025-04-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'BUHC',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'TJEM',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TJEM',
    submittedAt: '2025-02-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ISEC',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ISEC',
    submittedAt: '2025-01-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SAEC',
    submittedAt: '2025-02-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SAEC',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WVNT',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WVNT',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'DCMF',
    submittedAt: '2025-05-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'DCMF',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'IWCF',
    submittedAt: '2025-01-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'IWCF',
    submittedAt: '2025-02-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'IFOR',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IFOR',
    submittedAt: '2024-11-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'JXIW',
    submittedAt: '2025-04-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JXIW',
    submittedAt: '2025-05-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'TEZP',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'TEZP',
    submittedAt: '2025-04-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'THQR',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'THQR',
    submittedAt: '2024-12-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CJPE',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'CJPE',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SRQQ',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SRQQ',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'LZZX',
    submittedAt: '2025-01-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LZZX',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'NICT',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NICT',
    submittedAt: '2024-11-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VUOS',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'VUOS',
    submittedAt: '2024-12-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'MWTV',
    submittedAt: '2025-01-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MWTV',
    submittedAt: '2025-02-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VOTV',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VOTV',
    submittedAt: '2025-03-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ALSB',
    submittedAt: '2025-02-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ALSB',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZOWU',
    submittedAt: '2025-05-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZOWU',
    submittedAt: '2025-05-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'QEFO',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'QEFO',
    submittedAt: '2025-04-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'GDRC',
    submittedAt: '2025-01-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'GDRC',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ISBM',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ISBM',
    submittedAt: '2025-02-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RMBI',
    submittedAt: '2025-01-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RMBI',
    submittedAt: '2025-01-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'CEGY',
    submittedAt: '2025-02-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CEGY',
    submittedAt: '2025-03-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'BTTH',
    submittedAt: '2025-05-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BTTH',
    submittedAt: '2024-11-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'WBHX',
    submittedAt: '2025-03-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WBHX',
    submittedAt: '2025-04-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VTGG',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VTGG',
    submittedAt: '2024-11-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'JVNE',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JVNE',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'SUBW',
    submittedAt: '2024-11-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Initial Consult',
    patientId: 'SUBW',
    submittedAt: '2024-12-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'UQRG',
    submittedAt: '2025-04-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'UQRG',
    submittedAt: '2025-04-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BSJJ',
    submittedAt: '2024-11-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'BSJJ',
    submittedAt: '2024-11-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'PEQD',
    submittedAt: '2025-05-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PEQD',
    submittedAt: '2025-05-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'KFIB',
    submittedAt: '2025-01-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KFIB',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'LFBQ',
    submittedAt: '2025-04-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LFBQ',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VPOL',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'VPOL',
    submittedAt: '2024-11-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZJOV',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZJOV',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'FFDA',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FFDA',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ERCY',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ERCY',
    submittedAt: '2025-04-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'NQHU',
    submittedAt: '2025-01-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'NQHU',
    submittedAt: '2025-02-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'KSML',
    submittedAt: '2025-05-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KSML',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'GFPE',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GFPE',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'KJCX',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KJCX',
    submittedAt: '2025-02-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LRSO',
    submittedAt: '2024-11-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LRSO',
    submittedAt: '2024-12-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UZTF',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'UZTF',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SOYN',
    submittedAt: '2025-04-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SOYN',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'NPGE',
    submittedAt: '2025-01-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NPGE',
    submittedAt: '2025-01-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GWXH',
    submittedAt: '2024-11-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'GWXH',
    submittedAt: '2024-12-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ZFYR',
    submittedAt: '2025-03-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZFYR',
    submittedAt: '2025-03-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ROHM',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ROHM',
    submittedAt: '2025-03-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LXHO',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LXHO',
    submittedAt: '2024-12-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'POVD',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'POVD',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'JBCM',
    submittedAt: '2025-03-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JBCM',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XNAE',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XNAE',
    submittedAt: '2025-03-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HCBV',
    submittedAt: '2025-05-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'HCBV',
    submittedAt: '2025-05-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VMHC',
    submittedAt: '2025-01-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VMHC',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'DXIQ',
    submittedAt: '2025-01-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'DXIQ',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'RAUL',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RAUL',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'GPRY',
    submittedAt: '2025-02-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GPRY',
    submittedAt: '2025-03-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'NWJU',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NWJU',
    submittedAt: '2025-05-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HZSJ',
    submittedAt: '2025-03-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HZSJ',
    submittedAt: '2025-03-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BZDM',
    submittedAt: '2024-11-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BZDM',
    submittedAt: '2024-11-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ERCB',
    submittedAt: '2025-01-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ERCB',
    submittedAt: '2025-01-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IPOT',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IPOT',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WJMQ',
    submittedAt: '2025-01-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WJMQ',
    submittedAt: '2025-02-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XNYV',
    submittedAt: '2025-04-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'XNYV',
    submittedAt: '2025-05-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'HMIN',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HMIN',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ZQTX',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZQTX',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'FERB',
    submittedAt: '2025-04-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FERB',
    submittedAt: '2025-05-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'PZKH',
    submittedAt: '2025-03-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PZKH',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BBAR',
    submittedAt: '2025-03-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BBAR',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VLHW',
    submittedAt: '2024-11-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VLHW',
    submittedAt: '2024-12-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'BDRW',
    submittedAt: '2025-03-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BDRW',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SUNP',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'SUNP',
    submittedAt: '2025-01-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'WHXZ',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WHXZ',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ALCO',
    submittedAt: '2024-11-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ALCO',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WENP',
    submittedAt: '2024-11-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WENP',
    submittedAt: '2024-11-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EMSX',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'EMSX',
    submittedAt: '2025-04-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MXZI',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MXZI',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'BJQM',
    submittedAt: '2025-04-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BJQM',
    submittedAt: '2025-05-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UCCK',
    submittedAt: '2025-03-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'UCCK',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FAOX',
    submittedAt: '2025-03-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'FAOX',
    submittedAt: '2025-04-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'KOXK',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KOXK',
    submittedAt: '2024-11-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'VTRV',
    submittedAt: '2025-04-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VTRV',
    submittedAt: '2025-05-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'NVMN',
    submittedAt: '2025-04-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'NVMN',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'RXSY',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RXSY',
    submittedAt: '2025-04-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'CUCY',
    submittedAt: '2025-03-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CUCY',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'IUXW',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'IUXW',
    submittedAt: '2025-03-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LTHX',
    submittedAt: '2025-01-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'LTHX',
    submittedAt: '2025-01-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZYER',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZYER',
    submittedAt: '2025-04-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'OQJY',
    submittedAt: '2025-03-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OQJY',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'CFBD',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CFBD',
    submittedAt: '2025-05-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CSJR',
    submittedAt: '2025-04-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CSJR',
    submittedAt: '2025-05-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'LUPY',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LUPY',
    submittedAt: '2024-12-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'YDCF',
    submittedAt: '2025-03-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YDCF',
    submittedAt: '2025-03-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'FING',
    submittedAt: '2025-01-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'FING',
    submittedAt: '2025-02-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ACEL',
    submittedAt: '2025-03-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ACEL',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EJRF',
    submittedAt: '2025-05-22',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'EJRF',
    submittedAt: '2024-11-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FUNQ',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FUNQ',
    submittedAt: '2025-03-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'YNWJ',
    submittedAt: '2024-11-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'YNWJ',
    submittedAt: '2024-11-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WRBK',
    submittedAt: '2025-02-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WRBK',
    submittedAt: '2025-03-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ICRL',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ICRL',
    submittedAt: '2024-11-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VHUW',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VHUW',
    submittedAt: '2025-02-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'YUBO',
    submittedAt: '2025-05-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YUBO',
    submittedAt: '2025-05-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZFIY',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ZFIY',
    submittedAt: '2025-04-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'MSVP',
    submittedAt: '2025-04-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MSVP',
    submittedAt: '2025-04-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZLGK',
    submittedAt: '2025-04-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZLGK',
    submittedAt: '2025-05-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LEMP',
    submittedAt: '2025-02-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LEMP',
    submittedAt: '2025-03-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SQVV',
    submittedAt: '2025-02-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SQVV',
    submittedAt: '2025-03-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'INOO',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'INOO',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GLXG',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GLXG',
    submittedAt: '2025-01-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RLIB',
    submittedAt: '2024-11-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RLIB',
    submittedAt: '2024-11-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'PRRN',
    submittedAt: '2025-05-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PRRN',
    submittedAt: '2024-11-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IUZD',
    submittedAt: '2025-01-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IUZD',
    submittedAt: '2025-01-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ZJZM',
    submittedAt: '2025-01-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZJZM',
    submittedAt: '2025-01-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VFBL',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VFBL',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'KWCK',
    submittedAt: '2025-04-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KWCK',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'LJPC',
    submittedAt: '2025-03-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LJPC',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'KQXO',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KQXO',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'NRFA',
    submittedAt: '2024-11-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'NRFA',
    submittedAt: '2024-12-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'LFNW',
    submittedAt: '2025-05-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LFNW',
    submittedAt: '2025-05-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WVXJ',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'WVXJ',
    submittedAt: '2025-05-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'AFEY',
    submittedAt: '2025-01-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'AFEY',
    submittedAt: '2025-01-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QHNA',
    submittedAt: '2025-02-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QHNA',
    submittedAt: '2025-02-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SXQI',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'SXQI',
    submittedAt: '2025-05-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'YZOR',
    submittedAt: '2024-11-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YZOR',
    submittedAt: '2024-11-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'AOSN',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'AOSN',
    submittedAt: '2024-12-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'HGRZ',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'HGRZ',
    submittedAt: '2024-11-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'TZCC',
    submittedAt: '2025-03-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'TZCC',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WAKT',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WAKT',
    submittedAt: '2025-03-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MBNZ',
    submittedAt: '2025-04-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'MBNZ',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'YIRG',
    submittedAt: '2025-03-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'YIRG',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HYMA',
    submittedAt: '2025-04-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HYMA',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'CZTA',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CZTA',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'NKIX',
    submittedAt: '2025-03-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NKIX',
    submittedAt: '2025-04-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IRRF',
    submittedAt: '2025-03-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IRRF',
    submittedAt: '2025-03-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'RXTR',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RXTR',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'RVRR',
    submittedAt: '2024-11-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RVRR',
    submittedAt: '2024-11-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'JJIK',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JJIK',
    submittedAt: '2025-01-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'MAHM',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MAHM',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'GKML',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'GKML',
    submittedAt: '2024-11-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'KQOA',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KQOA',
    submittedAt: '2025-04-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'NYVY',
    submittedAt: '2025-04-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'NYVY',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UUBH',
    submittedAt: '2025-01-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'UUBH',
    submittedAt: '2025-01-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'PCPH',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PCPH',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'PAAM',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PAAM',
    submittedAt: '2025-04-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'AXBL',
    submittedAt: '2024-11-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'AXBL',
    submittedAt: '2024-11-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ZVIB',
    submittedAt: '2025-04-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ZVIB',
    submittedAt: '2025-05-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'YAFW',
    submittedAt: '2025-05-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'YAFW',
    submittedAt: '2025-05-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EUAR',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'EUAR',
    submittedAt: '2024-11-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WMOW',
    submittedAt: '2025-01-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'WMOW',
    submittedAt: '2025-02-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GWHD',
    submittedAt: '2024-11-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'GWHD',
    submittedAt: '2024-12-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'THRO',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'THRO',
    submittedAt: '2025-05-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MDVA',
    submittedAt: '2025-03-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MDVA',
    submittedAt: '2025-04-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LRKR',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'LRKR',
    submittedAt: '2024-11-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'GKQD',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GKQD',
    submittedAt: '2025-01-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QTCQ',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QTCQ',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'OWDA',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'OWDA',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'AWQZ',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'AWQZ',
    submittedAt: '2025-03-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SCTB',
    submittedAt: '2025-05-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'SCTB',
    submittedAt: '2024-11-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XPWP',
    submittedAt: '2025-02-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XPWP',
    submittedAt: '2025-03-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'LYUZ',
    submittedAt: '2025-04-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LYUZ',
    submittedAt: '2025-05-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'AQWP',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'AQWP',
    submittedAt: '2025-04-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'XXYJ',
    submittedAt: '2025-02-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XXYJ',
    submittedAt: '2025-03-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YCWL',
    submittedAt: '2025-05-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YCWL',
    submittedAt: '2025-05-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RFEW',
    submittedAt: '2025-01-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RFEW',
    submittedAt: '2025-02-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GQBR',
    submittedAt: '2025-05-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'GQBR',
    submittedAt: '2024-11-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OGIP',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'OGIP',
    submittedAt: '2025-01-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VXAS',
    submittedAt: '2024-11-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VXAS',
    submittedAt: '2024-12-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BJCZ',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BJCZ',
    submittedAt: '2024-11-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LSFF',
    submittedAt: '2025-05-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'LSFF',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WXIO',
    submittedAt: '2025-04-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WXIO',
    submittedAt: '2025-05-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FJAA',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FJAA',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RAXU',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RAXU',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HFLY',
    submittedAt: '2025-04-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'HFLY',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'KKLY',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KKLY',
    submittedAt: '2025-02-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QJSL',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QJSL',
    submittedAt: '2025-04-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WQLD',
    submittedAt: '2025-05-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WQLD',
    submittedAt: '2025-05-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PDML',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PDML',
    submittedAt: '2024-12-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SQCB',
    submittedAt: '2025-02-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SQCB',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RPAV',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RPAV',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BMYB',
    submittedAt: '2025-04-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'BMYB',
    submittedAt: '2025-04-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JOWG',
    submittedAt: '2025-02-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JOWG',
    submittedAt: '2025-03-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XAKR',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'XAKR',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'MCGG',
    submittedAt: '2025-04-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'MCGG',
    submittedAt: '2025-04-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ETBJ',
    submittedAt: '2025-04-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ETBJ',
    submittedAt: '2025-04-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ETSL',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ETSL',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DWJS',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'DWJS',
    submittedAt: '2025-04-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TDXJ',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'TDXJ',
    submittedAt: '2025-02-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CCIR',
    submittedAt: '2025-03-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CCIR',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZAYC',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZAYC',
    submittedAt: '2024-11-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BEAS',
    submittedAt: '2025-03-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BEAS',
    submittedAt: '2025-03-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'QXWR',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QXWR',
    submittedAt: '2024-11-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SUZY',
    submittedAt: '2025-01-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'SUZY',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CHLP',
    submittedAt: '2025-05-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CHLP',
    submittedAt: '2024-11-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HEQC',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HEQC',
    submittedAt: '2025-02-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JJEP',
    submittedAt: '2025-05-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JJEP',
    submittedAt: '2025-05-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JIKQ',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'JIKQ',
    submittedAt: '2025-03-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CJEE',
    submittedAt: '2025-03-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'CJEE',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WYQS',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WYQS',
    submittedAt: '2025-05-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DYWP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'DYWP',
    submittedAt: '2024-11-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OYFD',
    submittedAt: '2025-01-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'OYFD',
    submittedAt: '2025-02-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CGRB',
    submittedAt: '2025-03-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CGRB',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XZKN',
    submittedAt: '2025-01-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'XZKN',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TRJU',
    submittedAt: '2025-03-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TRJU',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OOQN',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OOQN',
    submittedAt: '2024-11-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VTFN',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VTFN',
    submittedAt: '2025-02-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'RJHS',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RJHS',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'QOKM',
    submittedAt: '2025-01-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QOKM',
    submittedAt: '2025-01-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DJTN',
    submittedAt: '2025-04-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'DJTN',
    submittedAt: '2025-04-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'FVGY',
    submittedAt: '2025-05-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FVGY',
    submittedAt: '2024-11-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TFRC',
    submittedAt: '2025-05-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'TFRC',
    submittedAt: '2025-05-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VGGI',
    submittedAt: '2025-03-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'VGGI',
    submittedAt: '2025-04-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YNAN',
    submittedAt: '2025-01-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'YNAN',
    submittedAt: '2025-01-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'IQIC',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IQIC',
    submittedAt: '2024-11-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'DIEK',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DIEK',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XYXJ',
    submittedAt: '2025-03-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'XYXJ',
    submittedAt: '2025-04-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YTKF',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YTKF',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZOWQ',
    submittedAt: '2025-05-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZOWQ',
    submittedAt: '2025-05-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JWGI',
    submittedAt: '2024-11-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JWGI',
    submittedAt: '2024-11-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PJLM',
    submittedAt: '2025-04-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PJLM',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WEMV',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WEMV',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RPTS',
    submittedAt: '2025-03-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RPTS',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UBET',
    submittedAt: '2025-02-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'UBET',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ENOW',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ENOW',
    submittedAt: '2025-05-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UIDH',
    submittedAt: '2025-02-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'UIDH',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'AERJ',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'AERJ',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OFAQ',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OFAQ',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ODVI',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ODVI',
    submittedAt: '2024-11-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RUDU',
    submittedAt: '2024-11-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RUDU',
    submittedAt: '2024-11-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'DVIW',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'DVIW',
    submittedAt: '2025-05-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'EOON',
    submittedAt: '2025-04-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EOON',
    submittedAt: '2025-05-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XWOS',
    submittedAt: '2025-03-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XWOS',
    submittedAt: '2025-03-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'NBJT',
    submittedAt: '2025-03-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'NBJT',
    submittedAt: '2025-03-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WIBA',
    submittedAt: '2025-05-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WIBA',
    submittedAt: '2024-11-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'IQJH',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IQJH',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'AUWB',
    submittedAt: '2025-03-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'AUWB',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'JUFZ',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'JUFZ',
    submittedAt: '2025-03-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UGLF',
    submittedAt: '2025-05-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'UGLF',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'PGRP',
    submittedAt: '2025-02-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'PGRP',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CUKE',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CUKE',
    submittedAt: '2025-03-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'YKVG',
    submittedAt: '2025-05-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'YKVG',
    submittedAt: '2024-11-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'LURT',
    submittedAt: '2025-03-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LURT',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EQAT',
    submittedAt: '2024-11-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'EQAT',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'TQZQ',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'TQZQ',
    submittedAt: '2025-04-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'FZMN',
    submittedAt: '2025-05-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FZMN',
    submittedAt: '2024-11-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'POOK',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'POOK',
    submittedAt: '2024-11-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'GSUY',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'GSUY',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MFGB',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MFGB',
    submittedAt: '2024-11-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'GDPA',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GDPA',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SVZY',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SVZY',
    submittedAt: '2025-04-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'EQTB',
    submittedAt: '2025-03-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EQTB',
    submittedAt: '2025-04-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'BNKK',
    submittedAt: '2025-05-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'BNKK',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'AJGU',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'AJGU',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SMSZ',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SMSZ',
    submittedAt: '2025-02-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'JMVU',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JMVU',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ZDMN',
    submittedAt: '2024-11-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ZDMN',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'KXAM',
    submittedAt: '2025-05-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KXAM',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TNRL',
    submittedAt: '2025-01-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TNRL',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MKGY',
    submittedAt: '2025-03-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MKGY',
    submittedAt: '2025-04-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'TEOA',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TEOA',
    submittedAt: '2024-11-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZUZY',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZUZY',
    submittedAt: '2024-11-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'AAVI',
    submittedAt: '2025-03-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'AAVI',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LDRO',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LDRO',
    submittedAt: '2025-05-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'RPSR',
    submittedAt: '2025-03-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RPSR',
    submittedAt: '2025-03-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'KSVQ',
    submittedAt: '2025-01-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KSVQ',
    submittedAt: '2025-02-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QLOB',
    submittedAt: '2025-05-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'QLOB',
    submittedAt: '2025-05-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'WYTA',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WYTA',
    submittedAt: '2024-12-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'THAS',
    submittedAt: '2024-11-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'THAS',
    submittedAt: '2024-11-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IQJQ',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IQJQ',
    submittedAt: '2025-03-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MXZF',
    submittedAt: '2025-01-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'MXZF',
    submittedAt: '2025-02-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OLYX',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OLYX',
    submittedAt: '2025-01-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZWQW',
    submittedAt: '2025-01-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZWQW',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SBSD',
    submittedAt: '2025-04-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'SBSD',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'VDIJ',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'VDIJ',
    submittedAt: '2024-11-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FELC',
    submittedAt: '2025-02-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ICHL',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ICHL',
    submittedAt: '2024-11-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SRWE',
    submittedAt: '2025-05-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'SRWE',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CZVU',
    submittedAt: '2025-04-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'CZVU',
    submittedAt: '2025-05-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HHFM',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HHFM',
    submittedAt: '2025-05-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'NOLR',
    submittedAt: '2024-11-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'NOLR',
    submittedAt: '2024-11-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'UULI',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'UULI',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'KSCD',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'KSCD',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UUSE',
    submittedAt: '2025-01-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UUSE',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LLAE',
    submittedAt: '2025-04-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LLAE',
    submittedAt: '2025-05-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CJNP',
    submittedAt: '2025-05-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CJNP',
    submittedAt: '2025-05-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'FTSV',
    submittedAt: '2025-01-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'FTSV',
    submittedAt: '2025-01-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'PVZI',
    submittedAt: '2025-02-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'PVZI',
    submittedAt: '2025-02-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CRCC',
    submittedAt: '2025-02-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CRCC',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LBQP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'LBQP',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ZIKM',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZIKM',
    submittedAt: '2025-04-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'QHWA',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QHWA',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WBNZ',
    submittedAt: '2024-11-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WBNZ',
    submittedAt: '2024-12-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'YXUH',
    submittedAt: '2025-03-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'YXUH',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'MXOY',
    submittedAt: '2025-04-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MXOY',
    submittedAt: '2025-05-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'RMTX',
    submittedAt: '2025-01-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'RMTX',
    submittedAt: '2025-01-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XCBY',
    submittedAt: '2025-04-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XCBY',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VNHX',
    submittedAt: '2025-01-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VNHX',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BJNS',
    submittedAt: '2025-02-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BJNS',
    submittedAt: '2025-02-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XEXZ',
    submittedAt: '2025-02-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XEXZ',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'BTZV',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'BTZV',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VGID',
    submittedAt: '2025-04-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VGID',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZQVB',
    submittedAt: '2025-03-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'ZQVB',
    submittedAt: '2025-04-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'JKWG',
    submittedAt: '2025-04-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'JKWG',
    submittedAt: '2025-04-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WLTH',
    submittedAt: '2025-05-22',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'WLTH',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ZLUI',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'ZLUI',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'EGKC',
    submittedAt: '2025-04-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EGKC',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'TKUF',
    submittedAt: '2025-03-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TKUF',
    submittedAt: '2025-04-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UTOF',
    submittedAt: '2025-04-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UTOF',
    submittedAt: '2025-05-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'KPER',
    submittedAt: '2025-04-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'KPER',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WTJQ',
    submittedAt: '2025-03-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WTJQ',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HTFU',
    submittedAt: '2024-11-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HTFU',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CPVP',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'CPVP',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OYFP',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OYFP',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'GOYK',
    submittedAt: '2025-01-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'GOYK',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EEXL',
    submittedAt: '2025-01-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'EEXL',
    submittedAt: '2025-02-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'NUTJ',
    submittedAt: '2025-02-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'NUTJ',
    submittedAt: '2025-02-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IVTM',
    submittedAt: '2025-04-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IVTM',
    submittedAt: '2025-04-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LFFE',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'LFFE',
    submittedAt: '2025-05-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZCOM',
    submittedAt: '2025-02-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZCOM',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BRHV',
    submittedAt: '2025-05-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BRHV',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'AAOF',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'AAOF',
    submittedAt: '2025-05-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RLDL',
    submittedAt: '2025-02-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RLDL',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'QZYN',
    submittedAt: '2025-05-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'QZYN',
    submittedAt: '2025-05-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VAUP',
    submittedAt: '2024-11-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'VAUP',
    submittedAt: '2024-11-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UKNJ',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'UKNJ',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EXWG',
    submittedAt: '2025-01-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'EXWG',
    submittedAt: '2025-01-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ENKZ',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ENKZ',
    submittedAt: '2025-03-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JFUO',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JFUO',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DFMH',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DFMH',
    submittedAt: '2025-05-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'KMAN',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KMAN',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WYZU',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'WYZU',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'DHAG',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'DHAG',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TAUV',
    submittedAt: '2025-01-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'TAUV',
    submittedAt: '2025-01-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FUMQ',
    submittedAt: '2024-11-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FUMQ',
    submittedAt: '2024-12-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'PYLA',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PYLA',
    submittedAt: '2025-03-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BBEY',
    submittedAt: '2025-04-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'BBEY',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JMUM',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JMUM',
    submittedAt: '2025-03-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YBHG',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YBHG',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'YORM',
    submittedAt: '2025-04-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YORM',
    submittedAt: '2025-04-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GOYQ',
    submittedAt: '2024-11-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'GOYQ',
    submittedAt: '2024-11-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WCXX',
    submittedAt: '2025-02-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WCXX',
    submittedAt: '2025-02-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BOOM',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'BOOM',
    submittedAt: '2025-04-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VAXJ',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'VAXJ',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WZOQ',
    submittedAt: '2025-04-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'WZOQ',
    submittedAt: '2025-04-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KPKW',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KPKW',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BTZZ',
    submittedAt: '2025-05-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BTZZ',
    submittedAt: '2024-11-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KKDX',
    submittedAt: '2025-05-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KKDX',
    submittedAt: '2025-05-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IEQW',
    submittedAt: '2025-02-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IEQW',
    submittedAt: '2025-03-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZFBV',
    submittedAt: '2025-01-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZFBV',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RCVR',
    submittedAt: '2025-03-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RCVR',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'RCGS',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'RCGS',
    submittedAt: '2025-02-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WHZL',
    submittedAt: '2025-01-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WHZL',
    submittedAt: '2025-02-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VPBE',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VPBE',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZBIC',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZBIC',
    submittedAt: '2025-01-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FJJK',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'FJJK',
    submittedAt: '2025-03-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DFAV',
    submittedAt: '2025-03-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DFAV',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UNPR',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'UNPR',
    submittedAt: '2025-05-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UAUS',
    submittedAt: '2024-11-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UAUS',
    submittedAt: '2024-12-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PPAD',
    submittedAt: '2025-05-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PPAD',
    submittedAt: '2024-11-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CPTQ',
    submittedAt: '2024-11-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'CPTQ',
    submittedAt: '2024-12-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PIBH',
    submittedAt: '2025-04-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PIBH',
    submittedAt: '2025-04-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'NAPN',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'NAPN',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'MUKC',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MUKC',
    submittedAt: '2025-05-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CSWJ',
    submittedAt: '2025-03-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CSWJ',
    submittedAt: '2025-04-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EART',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'EART',
    submittedAt: '2025-05-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'OHUR',
    submittedAt: '2025-05-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OHUR',
    submittedAt: '2025-05-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PKWD',
    submittedAt: '2025-05-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PKWD',
    submittedAt: '2025-05-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'UXWN',
    submittedAt: '2025-02-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'UXWN',
    submittedAt: '2025-02-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'NLBJ',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'NLBJ',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IJGI',
    submittedAt: '2025-04-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IJGI',
    submittedAt: '2025-04-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BLCB',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BLCB',
    submittedAt: '2024-12-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DEWZ',
    submittedAt: '2025-02-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'DEWZ',
    submittedAt: '2025-02-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'EIMS',
    submittedAt: '2025-03-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'EIMS',
    submittedAt: '2025-03-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PHGQ',
    submittedAt: '2025-02-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PHGQ',
    submittedAt: '2025-02-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CSAZ',
    submittedAt: '2025-03-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CSAZ',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ABJP',
    submittedAt: '2025-02-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ABJP',
    submittedAt: '2025-02-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JYEX',
    submittedAt: '2025-02-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JYEX',
    submittedAt: '2025-02-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ORFY',
    submittedAt: '2025-02-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ORFY',
    submittedAt: '2025-02-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'GKYQ',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'GKYQ',
    submittedAt: '2025-03-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OXRZ',
    submittedAt: '2025-01-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'OXRZ',
    submittedAt: '2025-01-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XJIZ',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'XJIZ',
    submittedAt: '2025-02-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZYDE',
    submittedAt: '2025-03-31',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZYDE',
    submittedAt: '2025-04-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EIFL',
    submittedAt: '2025-03-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'EIFL',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZGMQ',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZGMQ',
    submittedAt: '2024-11-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FOFY',
    submittedAt: '2025-04-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FOFY',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EGZS',
    submittedAt: '2025-02-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'EGZS',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YHHN',
    submittedAt: '2025-04-08',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'YHHN',
    submittedAt: '2025-04-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VUIT',
    submittedAt: '2025-01-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'VUIT',
    submittedAt: '2025-02-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PRNH',
    submittedAt: '2025-02-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PRNH',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LKKY',
    submittedAt: '2025-04-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LKKY',
    submittedAt: '2025-05-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'IFBG',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IFBG',
    submittedAt: '2025-05-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XGBQ',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'XGBQ',
    submittedAt: '2024-11-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YFNW',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YFNW',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'QSWP',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QSWP',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CWSI',
    submittedAt: '2025-01-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'CWSI',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YVQJ',
    submittedAt: '2024-11-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'YVQJ',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'KNDV',
    submittedAt: '2024-11-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KNDV',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'QVEF',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QVEF',
    submittedAt: '2024-12-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SEEK',
    submittedAt: '2024-11-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SEEK',
    submittedAt: '2024-12-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DCZH',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'DCZH',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JCTO',
    submittedAt: '2025-01-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JCTO',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UQAH',
    submittedAt: '2024-11-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UQAH',
    submittedAt: '2024-12-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FCZO',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FCZO',
    submittedAt: '2024-11-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'JXYS',
    submittedAt: '2025-01-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JXYS',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YGDU',
    submittedAt: '2025-05-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'YGDU',
    submittedAt: '2025-05-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'COOS',
    submittedAt: '2025-01-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'COOS',
    submittedAt: '2025-02-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'QAFM',
    submittedAt: '2025-02-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'QAFM',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'PQEG',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'PQEG',
    submittedAt: '2024-12-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TRRE',
    submittedAt: '2025-05-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'TRRE',
    submittedAt: '2025-05-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HMIG',
    submittedAt: '2025-01-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HMIG',
    submittedAt: '2025-02-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SKNC',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'SKNC',
    submittedAt: '2024-11-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'HJFP',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'HJFP',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'EDLC',
    submittedAt: '2025-05-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EDLC',
    submittedAt: '2025-05-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UBRA',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'UBRA',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VCDU',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'VCDU',
    submittedAt: '2025-04-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EUVZ',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EUVZ',
    submittedAt: '2025-04-06',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SLUD',
    submittedAt: '2024-11-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SLUD',
    submittedAt: '2024-12-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'UOWA',
    submittedAt: '2025-05-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'UOWA',
    submittedAt: '2025-05-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'LADT',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LADT',
    submittedAt: '2025-02-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'RAOY',
    submittedAt: '2025-02-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RAOY',
    submittedAt: '2025-03-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'MGMU',
    submittedAt: '2025-04-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MGMU',
    submittedAt: '2025-05-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WQFQ',
    submittedAt: '2025-03-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WQFQ',
    submittedAt: '2025-04-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IBSY',
    submittedAt: '2025-02-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IBSY',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'HXHY',
    submittedAt: '2024-11-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HXHY',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'RPLM',
    submittedAt: '2024-11-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RPLM',
    submittedAt: '2024-11-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RJXL',
    submittedAt: '2025-05-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'RJXL',
    submittedAt: '2024-11-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XYHM',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'XYHM',
    submittedAt: '2025-03-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'TBWL',
    submittedAt: '2025-05-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TBWL',
    submittedAt: '2025-05-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'HGHI',
    submittedAt: '2025-04-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HGHI',
    submittedAt: '2025-05-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XFTJ',
    submittedAt: '2025-02-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XFTJ',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'INCJ',
    submittedAt: '2025-03-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'INCJ',
    submittedAt: '2025-03-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LYXJ',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'LYXJ',
    submittedAt: '2025-03-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JYSO',
    submittedAt: '2025-01-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'JYSO',
    submittedAt: '2025-02-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RTJD',
    submittedAt: '2025-04-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'RTJD',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GITL',
    submittedAt: '2025-02-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'GITL',
    submittedAt: '2025-02-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ROYB',
    submittedAt: '2025-02-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ROYB',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CODB',
    submittedAt: '2024-11-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'CODB',
    submittedAt: '2024-12-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'CNVX',
    submittedAt: '2025-01-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'CNVX',
    submittedAt: '2025-01-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TGIR',
    submittedAt: '2025-03-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TGIR',
    submittedAt: '2025-04-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'NEOJ',
    submittedAt: '2025-02-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'NEOJ',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SRZK',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SRZK',
    submittedAt: '2025-03-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'JWXO',
    submittedAt: '2025-03-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'JWXO',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'FPSH',
    submittedAt: '2025-02-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'FPSH',
    submittedAt: '2025-02-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KXYY',
    submittedAt: '2025-01-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'KXYY',
    submittedAt: '2025-02-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'OPXG',
    submittedAt: '2025-01-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'OPXG',
    submittedAt: '2025-02-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VYFB',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'VYFB',
    submittedAt: '2025-01-24',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'YDNV',
    submittedAt: '2025-03-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'YDNV',
    submittedAt: '2025-03-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GSLJ',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'GSLJ',
    submittedAt: '2025-03-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'IUQF',
    submittedAt: '2025-04-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IUQF',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BGIU',
    submittedAt: '2025-01-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'BGIU',
    submittedAt: '2025-02-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CLXJ',
    submittedAt: '2025-05-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'CLXJ',
    submittedAt: '2024-11-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DEGF',
    submittedAt: '2025-01-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'DEGF',
    submittedAt: '2025-02-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WLDH',
    submittedAt: '2025-03-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'WLDH',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CGJY',
    submittedAt: '2025-02-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'CGJY',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZDZB',
    submittedAt: '2024-11-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ZDZB',
    submittedAt: '2024-11-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VAQB',
    submittedAt: '2025-03-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VAQB',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HLJA',
    submittedAt: '2025-04-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HLJA',
    submittedAt: '2025-05-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EGVH',
    submittedAt: '2025-02-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'EGVH',
    submittedAt: '2025-03-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'EDOA',
    submittedAt: '2025-03-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'EDOA',
    submittedAt: '2025-04-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TLLH',
    submittedAt: '2025-04-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'TLLH',
    submittedAt: '2025-04-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WSAF',
    submittedAt: '2025-04-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'WSAF',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'HWXB',
    submittedAt: '2025-03-02',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'HWXB',
    submittedAt: '2025-03-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ONKA',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'ONKA',
    submittedAt: '2025-05-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'HSOO',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'HSOO',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XJPZ',
    submittedAt: '2025-03-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XJPZ',
    submittedAt: '2025-04-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VPER',
    submittedAt: '2025-04-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'VPER',
    submittedAt: '2025-05-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KIUJ',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'KIUJ',
    submittedAt: '2025-03-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XGIN',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XGIN',
    submittedAt: '2024-12-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'RKHB',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'RKHB',
    submittedAt: '2024-11-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VHSF',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'VHSF',
    submittedAt: '2025-05-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FLID',
    submittedAt: '2025-02-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'FLID',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BZQG',
    submittedAt: '2025-04-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'BZQG',
    submittedAt: '2025-05-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SXGW',
    submittedAt: '2025-05-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'SXGW',
    submittedAt: '2024-11-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'LEOY',
    submittedAt: '2025-01-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'LEOY',
    submittedAt: '2025-02-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'TRTK',
    submittedAt: '2025-03-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'TRTK',
    submittedAt: '2025-04-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'UZWN',
    submittedAt: '2024-11-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'UZWN',
    submittedAt: '2024-12-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'MKXC',
    submittedAt: '2025-01-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'MKXC',
    submittedAt: '2025-01-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QQPN',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'QQPN',
    submittedAt: '2025-04-28',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'TDYV',
    submittedAt: '2025-04-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'TDYV',
    submittedAt: '2025-05-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GPHN',
    submittedAt: '2025-05-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'GPHN',
    submittedAt: '2024-11-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'OOJV',
    submittedAt: '2025-01-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'OOJV',
    submittedAt: '2025-01-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ALRB',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'ALRB',
    submittedAt: '2024-11-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'OEOD',
    submittedAt: '2025-02-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'OEOD',
    submittedAt: '2025-03-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GWZK',
    submittedAt: '2025-05-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'GWZK',
    submittedAt: '2024-11-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SDQC',
    submittedAt: '2025-03-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SDQC',
    submittedAt: '2025-04-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'PPOW',
    submittedAt: '2025-05-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'PPOW',
    submittedAt: '2025-05-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'XKGA',
    submittedAt: '2025-04-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'XKGA',
    submittedAt: '2025-05-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XEZB',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'XEZB',
    submittedAt: '2025-03-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VGWF',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'VGWF',
    submittedAt: '2024-12-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SGQI',
    submittedAt: '2025-05-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Follow Up',
    patientId: 'SGQI',
    submittedAt: '2024-11-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GMPQ',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Follow Up',
    patientId: 'GMPQ',
    submittedAt: '2024-12-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'DDJA',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'DDJA',
    submittedAt: '2024-11-11',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WRPF',
    submittedAt: '2024-11-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Follow Up',
    patientId: 'WRPF',
    submittedAt: '2024-11-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IJED',
    submittedAt: '2025-02-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Follow Up',
    patientId: 'IJED',
    submittedAt: '2025-03-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'HCSG',
    submittedAt: '2025-05-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HCSG',
    submittedAt: '2025-05-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FVZO',
    submittedAt: '2025-02-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FVZO',
    submittedAt: '2025-03-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YZWB',
    submittedAt: '2025-02-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YZWB',
    submittedAt: '2025-02-28',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'HZLT',
    submittedAt: '2025-02-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HZLT',
    submittedAt: '2025-02-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BDHE',
    submittedAt: '2024-11-05',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BDHE',
    submittedAt: '2024-11-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'BUHC',
    submittedAt: '2025-04-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'BUHC',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'TJEM',
    submittedAt: '2025-01-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'TJEM',
    submittedAt: '2025-02-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ISEC',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ISEC',
    submittedAt: '2025-01-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SAEC',
    submittedAt: '2025-02-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SAEC',
    submittedAt: '2025-02-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WVNT',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WVNT',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DCMF',
    submittedAt: '2025-05-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'DCMF',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IWCF',
    submittedAt: '2025-01-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'IWCF',
    submittedAt: '2025-02-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'IFOR',
    submittedAt: '2024-11-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IFOR',
    submittedAt: '2024-11-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JXIW',
    submittedAt: '2025-04-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'JXIW',
    submittedAt: '2025-05-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'TEZP',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'TEZP',
    submittedAt: '2025-04-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'THQR',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'THQR',
    submittedAt: '2024-12-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CJPE',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'CJPE',
    submittedAt: '2024-11-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'SRQQ',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SRQQ',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LZZX',
    submittedAt: '2025-01-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LZZX',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NICT',
    submittedAt: '2024-11-08',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NICT',
    submittedAt: '2024-11-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VUOS',
    submittedAt: '2024-11-06',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VUOS',
    submittedAt: '2024-12-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'MWTV',
    submittedAt: '2025-01-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MWTV',
    submittedAt: '2025-02-03',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VOTV',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VOTV',
    submittedAt: '2025-03-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ALSB',
    submittedAt: '2025-02-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ALSB',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZOWU',
    submittedAt: '2025-05-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZOWU',
    submittedAt: '2025-05-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'QEFO',
    submittedAt: '2025-03-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'QEFO',
    submittedAt: '2025-04-01',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'GDRC',
    submittedAt: '2025-01-22',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'GDRC',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ISBM',
    submittedAt: '2025-01-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ISBM',
    submittedAt: '2025-02-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RMBI',
    submittedAt: '2025-01-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RMBI',
    submittedAt: '2025-01-17',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'CEGY',
    submittedAt: '2025-02-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CEGY',
    submittedAt: '2025-03-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'BTTH',
    submittedAt: '2025-05-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BTTH',
    submittedAt: '2024-11-09',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WBHX',
    submittedAt: '2025-03-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WBHX',
    submittedAt: '2025-04-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VTGG',
    submittedAt: '2024-11-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VTGG',
    submittedAt: '2024-11-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JVNE',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'JVNE',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'SUBW',
    submittedAt: '2024-11-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'SUBW',
    submittedAt: '2024-12-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'UQRG',
    submittedAt: '2025-04-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'UQRG',
    submittedAt: '2025-04-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BSJJ',
    submittedAt: '2024-11-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'BSJJ',
    submittedAt: '2024-11-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'PEQD',
    submittedAt: '2025-05-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PEQD',
    submittedAt: '2025-05-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KFIB',
    submittedAt: '2025-01-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KFIB',
    submittedAt: '2025-01-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'LFBQ',
    submittedAt: '2025-04-17',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LFBQ',
    submittedAt: '2025-05-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VPOL',
    submittedAt: '2024-11-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'VPOL',
    submittedAt: '2024-11-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZJOV',
    submittedAt: '2025-04-11',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZJOV',
    submittedAt: '2025-04-23',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'FFDA',
    submittedAt: '2025-04-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'FFDA',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ERCY',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ERCY',
    submittedAt: '2025-04-29',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'NQHU',
    submittedAt: '2025-01-27',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'NQHU',
    submittedAt: '2025-02-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'KSML',
    submittedAt: '2025-05-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'KSML',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'GFPE',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GFPE',
    submittedAt: '2025-05-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KJCX',
    submittedAt: '2025-01-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KJCX',
    submittedAt: '2025-02-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LRSO',
    submittedAt: '2024-11-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'LRSO',
    submittedAt: '2024-12-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'UZTF',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'UZTF',
    submittedAt: '2024-12-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SOYN',
    submittedAt: '2025-04-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SOYN',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'NPGE',
    submittedAt: '2025-01-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NPGE',
    submittedAt: '2025-01-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GWXH',
    submittedAt: '2024-11-19',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'GWXH',
    submittedAt: '2024-12-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZFYR',
    submittedAt: '2025-03-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZFYR',
    submittedAt: '2025-03-17',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ROHM',
    submittedAt: '2025-03-18',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ROHM',
    submittedAt: '2025-03-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'LXHO',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'LXHO',
    submittedAt: '2024-12-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'POVD',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'POVD',
    submittedAt: '2024-11-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'JBCM',
    submittedAt: '2025-03-31',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JBCM',
    submittedAt: '2025-04-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'XNAE',
    submittedAt: '2025-03-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'XNAE',
    submittedAt: '2025-03-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'HCBV',
    submittedAt: '2025-05-16',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'HCBV',
    submittedAt: '2025-05-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VMHC',
    submittedAt: '2025-01-04',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VMHC',
    submittedAt: '2025-01-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'DXIQ',
    submittedAt: '2025-01-12',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'DXIQ',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'RAUL',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RAUL',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'GPRY',
    submittedAt: '2025-02-26',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GPRY',
    submittedAt: '2025-03-05',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'NWJU',
    submittedAt: '2025-05-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NWJU',
    submittedAt: '2025-05-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'HZSJ',
    submittedAt: '2025-03-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HZSJ',
    submittedAt: '2025-03-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BZDM',
    submittedAt: '2024-11-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BZDM',
    submittedAt: '2024-11-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ERCB',
    submittedAt: '2025-01-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ERCB',
    submittedAt: '2025-01-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IPOT',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'IPOT',
    submittedAt: '2025-05-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WJMQ',
    submittedAt: '2025-01-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WJMQ',
    submittedAt: '2025-02-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'XNYV',
    submittedAt: '2025-04-27',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'XNYV',
    submittedAt: '2025-05-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'HMIN',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'HMIN',
    submittedAt: '2025-03-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZQTX',
    submittedAt: '2024-11-13',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ZQTX',
    submittedAt: '2024-11-21',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'FERB',
    submittedAt: '2025-04-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FERB',
    submittedAt: '2025-05-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PZKH',
    submittedAt: '2025-03-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'PZKH',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BBAR',
    submittedAt: '2025-03-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BBAR',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'VLHW',
    submittedAt: '2024-11-12',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'VLHW',
    submittedAt: '2024-12-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'BDRW',
    submittedAt: '2025-03-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'BDRW',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SUNP',
    submittedAt: '2025-01-12',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'SUNP',
    submittedAt: '2025-01-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'WHXZ',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WHXZ',
    submittedAt: '2025-04-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ALCO',
    submittedAt: '2024-11-14',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ALCO',
    submittedAt: '2024-11-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WENP',
    submittedAt: '2024-11-09',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WENP',
    submittedAt: '2024-11-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'EMSX',
    submittedAt: '2025-03-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'EMSX',
    submittedAt: '2025-04-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'MXZI',
    submittedAt: '2025-02-30',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MXZI',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'BJQM',
    submittedAt: '2025-04-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'BJQM',
    submittedAt: '2025-05-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'UCCK',
    submittedAt: '2025-03-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'UCCK',
    submittedAt: '2025-04-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FAOX',
    submittedAt: '2025-03-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'FAOX',
    submittedAt: '2025-04-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'KOXK',
    submittedAt: '2024-11-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KOXK',
    submittedAt: '2024-11-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'VTRV',
    submittedAt: '2025-04-15',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'VTRV',
    submittedAt: '2025-05-03',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'NVMN',
    submittedAt: '2025-04-10',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'NVMN',
    submittedAt: '2025-04-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RXSY',
    submittedAt: '2025-03-24',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RXSY',
    submittedAt: '2025-04-17',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CUCY',
    submittedAt: '2025-03-15',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CUCY',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'IUXW',
    submittedAt: '2025-02-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'IUXW',
    submittedAt: '2025-03-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'LTHX',
    submittedAt: '2025-01-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'LTHX',
    submittedAt: '2025-01-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZYER',
    submittedAt: '2025-04-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZYER',
    submittedAt: '2025-04-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'OQJY',
    submittedAt: '2025-03-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'OQJY',
    submittedAt: '2025-04-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CFBD',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CFBD',
    submittedAt: '2025-05-23',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'CSJR',
    submittedAt: '2025-04-15',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'CSJR',
    submittedAt: '2025-05-05',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'LUPY',
    submittedAt: '2024-11-27',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'LUPY',
    submittedAt: '2024-12-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YDCF',
    submittedAt: '2025-03-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YDCF',
    submittedAt: '2025-03-14',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'FING',
    submittedAt: '2025-01-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'FING',
    submittedAt: '2025-02-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ACEL',
    submittedAt: '2025-03-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ACEL',
    submittedAt: '2025-04-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'EJRF',
    submittedAt: '2025-05-22',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'EJRF',
    submittedAt: '2024-11-01',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'FUNQ',
    submittedAt: '2025-02-13',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'FUNQ',
    submittedAt: '2025-03-07',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YNWJ',
    submittedAt: '2024-11-10',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'YNWJ',
    submittedAt: '2024-11-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WRBK',
    submittedAt: '2025-02-16',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'WRBK',
    submittedAt: '2025-03-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ICRL',
    submittedAt: '2024-11-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'ICRL',
    submittedAt: '2024-11-24',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'VHUW',
    submittedAt: '2025-02-25',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VHUW',
    submittedAt: '2025-02-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YUBO',
    submittedAt: '2025-05-11',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'YUBO',
    submittedAt: '2025-05-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'ZFIY',
    submittedAt: '2025-03-30',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ZFIY',
    submittedAt: '2025-04-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'MSVP',
    submittedAt: '2025-04-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MSVP',
    submittedAt: '2025-04-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'ZLGK',
    submittedAt: '2025-04-29',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'ZLGK',
    submittedAt: '2025-05-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'LEMP',
    submittedAt: '2025-02-20',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LEMP',
    submittedAt: '2025-03-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'SQVV',
    submittedAt: '2025-02-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'SQVV',
    submittedAt: '2025-03-04',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'INOO',
    submittedAt: '2025-03-30',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'INOO',
    submittedAt: '2025-03-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GLXG',
    submittedAt: '2025-01-04',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GLXG',
    submittedAt: '2025-01-14',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'RLIB',
    submittedAt: '2024-11-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RLIB',
    submittedAt: '2024-11-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'PRRN',
    submittedAt: '2025-05-31',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PRRN',
    submittedAt: '2024-11-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IUZD',
    submittedAt: '2025-01-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IUZD',
    submittedAt: '2025-01-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'ZJZM',
    submittedAt: '2025-01-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'ZJZM',
    submittedAt: '2025-01-18',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'VFBL',
    submittedAt: '2025-02-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'VFBL',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'KWCK',
    submittedAt: '2025-04-12',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KWCK',
    submittedAt: '2025-05-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LJPC',
    submittedAt: '2025-03-22',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'LJPC',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'KQXO',
    submittedAt: '2025-03-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'KQXO',
    submittedAt: '2025-04-14',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NRFA',
    submittedAt: '2024-11-09',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Initial Consult',
    patientId: 'NRFA',
    submittedAt: '2024-12-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'LFNW',
    submittedAt: '2025-05-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'LFNW',
    submittedAt: '2025-05-23',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'WVXJ',
    submittedAt: '2025-04-15',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'WVXJ',
    submittedAt: '2025-05-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'AFEY',
    submittedAt: '2025-01-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'AFEY',
    submittedAt: '2025-01-29',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QHNA',
    submittedAt: '2025-02-06',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QHNA',
    submittedAt: '2025-02-10',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'SXQI',
    submittedAt: '2025-04-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'SXQI',
    submittedAt: '2025-05-25',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'YZOR',
    submittedAt: '2024-11-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'YZOR',
    submittedAt: '2024-11-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'AOSN',
    submittedAt: '2024-11-24',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Initial Consult',
    patientId: 'AOSN',
    submittedAt: '2024-12-04',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'HGRZ',
    submittedAt: '2024-11-08',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'HGRZ',
    submittedAt: '2024-11-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'TZCC',
    submittedAt: '2025-03-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'TZCC',
    submittedAt: '2025-03-31',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'WAKT',
    submittedAt: '2025-02-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'WAKT',
    submittedAt: '2025-03-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'MBNZ',
    submittedAt: '2025-04-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'MBNZ',
    submittedAt: '2025-04-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YIRG',
    submittedAt: '2025-03-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'YIRG',
    submittedAt: '2025-03-21',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'HYMA',
    submittedAt: '2025-04-19',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'HYMA',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'CZTA',
    submittedAt: '2025-02-28',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'CZTA',
    submittedAt: '2025-02-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NKIX',
    submittedAt: '2025-03-18',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'NKIX',
    submittedAt: '2025-04-11',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'IRRF',
    submittedAt: '2025-03-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'IRRF',
    submittedAt: '2025-03-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'RXTR',
    submittedAt: '2025-04-21',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'RXTR',
    submittedAt: '2025-05-03',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'RVRR',
    submittedAt: '2024-11-07',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'RVRR',
    submittedAt: '2024-11-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'JJIK',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'JJIK',
    submittedAt: '2025-01-20',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'MAHM',
    submittedAt: '2025-01-26',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'MAHM',
    submittedAt: '2025-02-19',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'GKML',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'GKML',
    submittedAt: '2024-11-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'KQOA',
    submittedAt: '2025-04-07',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'KQOA',
    submittedAt: '2025-04-30',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'NYVY',
    submittedAt: '2025-04-26',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'NYVY',
    submittedAt: '2025-05-21',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'UUBH',
    submittedAt: '2025-01-02',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'UUBH',
    submittedAt: '2025-01-13',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Sim Education',
    patientId: 'PCPH',
    submittedAt: '2025-05-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'PCPH',
    submittedAt: '2025-05-29',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'PAAM',
    submittedAt: '2025-03-28',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'PAAM',
    submittedAt: '2025-04-18',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'AXBL',
    submittedAt: '2024-11-06',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'AXBL',
    submittedAt: '2024-11-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'ZVIB',
    submittedAt: '2025-04-23',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'ZVIB',
    submittedAt: '2025-05-09',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'YAFW',
    submittedAt: '2025-05-19',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'YAFW',
    submittedAt: '2025-05-25',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'EUAR',
    submittedAt: '2025-05-13',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'EUAR',
    submittedAt: '2024-11-03',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Adams',
    appointmentType: 'Sim Education',
    patientId: 'WMOW',
    submittedAt: '2025-01-16',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Adams',
    appointmentType: 'Treatment Review',
    patientId: 'WMOW',
    submittedAt: '2025-02-10',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'GWHD',
    submittedAt: '2024-11-22',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Initial Consult',
    patientId: 'GWHD',
    submittedAt: '2024-12-01',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'THRO',
    submittedAt: '2025-05-05',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Lopez',
    appointmentType: 'Treatment Review',
    patientId: 'THRO',
    submittedAt: '2025-05-27',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'MDVA',
    submittedAt: '2025-03-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'MDVA',
    submittedAt: '2025-04-20',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'LRKR',
    submittedAt: '2024-11-02',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'LRKR',
    submittedAt: '2024-11-26',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Lakeside',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'GKQD',
    submittedAt: '2025-01-01',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'GKQD',
    submittedAt: '2025-01-16',
    location: 'Machine 2',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Wong',
    appointmentType: 'Sim Education',
    patientId: 'QTCQ',
    submittedAt: '2025-02-07',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Wong',
    appointmentType: 'Treatment Review',
    patientId: 'QTCQ',
    submittedAt: '2025-02-20',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'OWDA',
    submittedAt: '2025-03-08',
    location: 'Machine 3',
    status: 'active',
  },
  {
    treatingDepartment: 'Rosebush',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'OWDA',
    submittedAt: '2025-04-02',
    location: 'Machine 4',
    status: 'active',
  },
  {
    treatingDepartment: 'Campsie',
    physician: 'Dr Lopez',
    appointmentType: 'Sim Education',
    patientId: 'AWQZ',
    submittedAt: '2025-02-25',
    location: 'Machine 1',
    status: 'active',
  },
  {
    treatingDepartment: 'Red Hills',
    physician: 'Dr Smith',
    appointmentType: 'Treatment Review',
    patientId: 'AWQZ',
    submittedAt: '2025-03-16',
    location: 'Machine 3',
    status: 'active',
  },
];

export default MockData;
